<template>
    <div class="aging-config">
        <el-table class="table-header" height="34px">
            <el-table-column
                v-for="(column,index) in columns"
                :key="index"
                :label="column.label"
                :prop="column.prop"
                :min-width="column.width"
            ></el-table-column>
            <el-table-column v-if="btnType !== 'check'"
                label="操作"
                width="100"
            ></el-table-column>
        </el-table>
        <template>
            <el-collapse class="aging-collapse" v-model="activeNames">
                <el-collapse-item v-for="(agingConfig, index) in agingConfigs" :key="index" :name="index + 1">
                    <template slot="title">
                        <div class="aging-config-header">
                            <span>{{agingConfig.title}}</span>
                            <!-- <span class="total-elapsed-time">总历时：{{agingConfig.totalElapsedTime}}</span> -->
                        </div>
                    </template>
                    <dialogTable
                        :tableData="agingConfig.customerAgingConfigDatailList"
                        :dialogTable="agingConfigDialogTable(index)"
                        :ref="'agingDialogTable'+index"
                        @dialogDelRow="dialogDelRow"
                        @change="elementChange"
                    >
                        <template slot="myFooter">
                            <div class="tableFooter">
                                <el-button type="text" @click="addDialogRow(`agingDialogTable${index}`, index)" :disabled="!config.dialog.agingConfigTable.btnActive">+ 添加明细</el-button>
                            </div>
                        </template>
                    </dialogTable>
                </el-collapse-item>
            </el-collapse>
        </template>
    </div>
</template>
<script>
import _ from 'lodash';
import dialogTable from './DialogTable';
export default {
    name: 'agingConfig',
    components: { dialogTable },
    props: {
        config: {
            type: Object,
            default: () => {
                return {};
            }
        },
        customerAgingStationList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        customerAgingConfigDatailList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        agingStartTime: {
            type: String,
            default: ''
        },
        btnType: {
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    computed: {
        agingConfigDialogTable: function(index) {
            return function(index) {
                if (index === 0) {
                    if (this.formData.orderType !== 'DO') {
                        return this.config.dialog.agingConfigTable1;
                    } else {
                        return this.config.dialog.agingConfigTableDO;
                    }
                }
                return this.config.dialog.agingConfigTable;
            };
        }
    },
    data() {
        return {
            columns: [
                { label: '订单状态', prop: 'status' },
                { label: '时效要求', prop: 'agingReqTime' },
                { label: '预警', prop: 'warnHour' },
                { label: '计算起点', prop: 'begainStatus' },
                { label: '历时（小时）', prop: 'agingHour' }
            ],
            agingConfigs: this.customerAgingStationList,
            activeNames: [1]
        };
    },
    methods: {
        dialogDelRow(row, index, data) {
            data.splice(index, 1);
            this.getAgingConfigsTotalElapsedTime();
        },
        getAgingConfigsTotalElapsedTime() {
            this.agingConfigs = this.customerAgingStationList.map(item => {
                item.customerAgingConfigDatailList.forEach(c => {
                    item.totalElapsedTime = this.getTotalElapsedTime(item.customerAgingConfigDatailList);
                });
                return item;
            });
        },
        addDialogRow(ref, index) {
            this.$refs[ref][0].addRow();
            const rowAgingConfigDatailList = this.agingConfigs[index].customerAgingConfigDatailList || [];
            this.agingConfigs[index].customerAgingConfigDatailList = rowAgingConfigDatailList.map(item => {
                item.sortNo = item.sortNo || this.agingConfigs[index].sortNo;
                return item;
            });
            const customerAgingConfigDatailList = this.agingConfigs.map(item => item.customerAgingConfigDatailList).flat();
            this.$emit('update:customerAgingConfigDatailList', customerAgingConfigDatailList);
        },
        getItemTotalElapsedTime(data, start, end) {
            const minuend = data.filter(item => +item.status === start);
            const reduction = data.filter(item => +item.status === end);
            return _.get(minuend[0], 'agingHour', 0) - _.get(reduction[0], 'agingHour', 0);
        },
        getTotalElapsedTime(data) {
            const statusArr = data.map(item => +item.status);
            if (statusArr.includes(605) && statusArr.includes(370)) {
                return this.getItemTotalElapsedTime(data, 605, 370);
            } else if (statusArr.includes(380) && statusArr.includes(370)) {
                return this.getItemTotalElapsedTime(data, 380, 370);
            } else if (statusArr.includes(380) && statusArr.includes(450)) {
                return this.getItemTotalElapsedTime(data, 380, 450);
            } else if (statusArr.includes(610) && statusArr.includes(370)) {
                return this.getItemTotalElapsedTime(data, 610, 370);
            } else if (statusArr.includes(870) && statusArr.includes(770)) {
                return this.getItemTotalElapsedTime(data, 870, 770);
            }
            return 0;
        },
        elementChange({ data, row, prop }) {
            if (prop === 'agingReqTime') {
                const hour = this.getAgingStartTimeHour(this.agingStartTime);
                const agingReqTime = (+row.agingReqDay || 0) * 24 + (+row.agingReqHour || 0);
                this.$set(row, 'agingHour', agingReqTime - hour);
            }
            if (prop !== 'agingReqTime' && data.column.property === 'agingHour') {
                var reg = /^\+?[1-9][0-9]*$/;// 正整数
                const flag = reg.test(data.row.agingHour * 1);
                if (!flag) {
                    this.$set(data.row, 'agingHour', '');
                    return this.$message.warning('只能输入正整数！');
                }
                if (data.row.agingHour * 1 > 1223) {
                    this.$set(data.row, 'agingHour', '');
                    return this.$message.warning('最大输入数为1223！');
                }
                const hour = this.getAgingStartTimeHour(this.agingStartTime);
                const allHour = data.row.agingHour * 1 + hour;
                const agingReqDay = parseInt(allHour / 24);
                const agingReqHour = allHour % 24;
                this.$set(data.row, 'agingReqDay', agingReqDay);
                this.$set(data.row, 'agingReqHour', agingReqHour);
            }
            this.getAgingConfigsTotalElapsedTime();
        },
        getAgingStartTimeHour(val) {
            let hour = val.split(':')[0];
            hour = hour.indexOf('+') > -1 ? Number(hour.split('+')[1]) + 24 : Number(hour);
            return hour;
        }
    },
    watch: {
        // 总历时：根据减数和被减数是否都为空依次优先取以下计算值：
        // 已抵达（605）历时-已发车（370）历时
        // 到达分拨仓（380）历时-已发车（370）历时
        // 到达分拨仓历时（380）-分拨仓在途（450）历时
        // 支线到达（610）历时-已发车（370）历时
        // 全部入库（870）历时-网点发货（770）历时
        customerAgingStationList: {
            handler: function (newValue, oldValue) {
                // const hour = this.getAgingStartTimeHour(this.agingStartTime);
                this.agingConfigs = newValue.map((item, index) => {
                    item.title = `站点仓库-${item.sortNo}：${item.whName || ''}`;
                    item.customerAgingConfigDatailList = item.customerAgingConfigDatailList || [];
                    // item.customerAgingConfigDatailList.forEach(c => {
                    //     const agingReqTime = (+c.agingReqDay || 0) * 24 + (+c.agingReqHour || 0);
                    //     this.$set(c, 'agingHour', agingReqTime - hour);
                    // });
                    item.totalElapsedTime = this.getTotalElapsedTime(item.customerAgingConfigDatailList);
                    return item;
                });
            },
            deep: true
        },
        agingStartTime: function(newValue, oldValue) {
            const hour = this.getAgingStartTimeHour(newValue);
            this.agingConfigs = this.agingConfigs.map((item, index) => {
                item.customerAgingConfigDatailList = item.customerAgingConfigDatailList.map(c => {
                    const agingReqTime = (+c.agingReqDay || 0) * 24 + (+c.agingReqHour || 0);
                    this.$set(c, 'agingHour', agingReqTime - hour);
                    return c;
                });
                return item;
            });
        }
    }
};
</script>